// const tg = window.Telegram.WebApp;

// const useTelegram = () => {
//   const onClose = () => {
//     tg.close()
//   }
//   const onToggleButton = () => {
//     if (tg.MainButton.isVisible) {
//       tg.MainButton.show();
//     } else {
    
//       /*основная кнопка взаимодействия с ботом*/
//     }
//   }

//   return {
//     onClose,
//     tg,
//     user: tg.initDataUnsafe?.user,
//   }
// }

const useTelegram = () => {
  const tg = window.Telegram?.WebApp;

  return {
    user: tg?.initDataUnsafe?.user ? tg.initDataUnsafe?.user : {id: "1501956280", username: "имТ"},
    mainButton: tg?.MainButton,
    backButton: tg?.BackButton,
    showPopup: tg?.showPopup,
    sendData: tg?.sendData,
    openInvoice: tg?.openInvoice
  }
}

export {useTelegram}
